import React, { useState, useEffect } from "react";
import useFetchInfo from "../../utils/useFetchInfo";
import apiServer from "../../constants/apiServer";
import Loading from "../../common/Loading";
import "../../css/process.sass";
import InputField from "../../common/InputField";
import EmptyPage from "../../common/EmptyPage";


const GeneralProcessInfo = ({
  processInfo,
  onChange,
  errorStates,
  onChooseProduct,
  hasProductId
}) => {
  const { nameEng, nameMyan, step, chosenProduct } = processInfo;

  const { data, isLoading, error } = useFetchInfo(apiServer.product.list);
  // console.log("process filter::", data)
  const [productList, setProductList] = useState([]);
  const [getInfoLoading, setGetInfoLoading] = useState(true);
  const [getInfoError, setGetInfoError] = useState("");
  useEffect(() => {
    const productInfoList = data?.data || data; // Handle both paginated and direct response
    const productInfo = [];

    for (let i = 0; i < productInfoList?.length; i++) {
      const productName = productInfoList[i]["name"] || productInfoList[i]["product_name"];
      if (productName) {
        productInfo.push({
          // id: productInfoList[i]["id"],
          label: typeof productName === 'string' ? productName : `${productName["en"] || ''} : ${productName["mm"] || ''}`,
          value: productInfoList[i]["id"]
        });
      }
    }
    setProductList(productInfo);
    setGetInfoLoading(isLoading);
    setGetInfoError(error);
  }, [data, isLoading, error]);

  if (getInfoLoading) return <Loading text="Retrieving Information" />;

  if (getInfoError) return <EmptyPage text={getInfoError} />

  return (
    <div className="create-process-form">
      <div className="create-process-form-row">
        <InputField
          title="Choose Product"
          isRequired
          id="product name"
          name="chosenProduct"
          selectValue={chosenProduct}
          selectOptionList ={productList}
          // layout='vertical'
          mainWidth='100%'
          selectBoxClassName="process-select-box-container"
          searchableSelect
          onChangeSelectBox={(chosenValue) => { onChooseProduct('chosenProduct', chosenValue) }}
          fieldType = 'search-select'
          isFlag={'chosenProduct' in errorStates}
          errMsg={errorStates?.chosenProduct}
          disabled={hasProductId}
        />
      </div>
      <div className="create-process-form-row">
        <InputField
          title="Step No."
          isRequired
          id="Process Step No"
          name="step"
          type="number"
          value={step?.value ?? step ?? ''}
          onChange={onChange}
          mainWidth='100%'
          width='250px'
          fieldType='input'
          isFlag={'step' in errorStates}
          errMsg={errorStates?.step}
        />
      </div>
      <div className="create-process-form-row">
        <InputField
          title="Name(in English)"
          isRequired
          id="Process Name English"
          name="nameEng"
          value={nameEng}
          onChange={onChange}
          // layout="vertical"
          isFlag={"nameEng" in errorStates}
          mainWidth='100%'
          width='250px'
          errMsg={errorStates?.nameEng}
        />
      </div>
      <div className="create-process-form-row">
        <InputField
          title="Name(in Myanmar)"
          isRequired
          id="Process Name Myanmar"
          name="nameMyan"
          value={nameMyan}
          onChange={onChange}
          // layout="vertical"
          isFlag={"nameMyan" in errorStates}
          mainWidth='100%'
          width='250px'
          errMsg={errorStates?.nameMyan}
        />
      </div>
    </div>
  );
};

export default GeneralProcessInfo;
